var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          title: _vm.$t("questions"),
          data: _vm.questions,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.fetchData
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new_f")
                  },
                  on: {
                    click: function($event) {
                      return _vm.addQuestion()
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "move", attrs: { "auto-width": "", props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-arrow-up",
                          disable: props.row.question_order === 1 || _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "up")
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-arrow-down",
                          disable:
                            props.row.question_order === _vm.questions.length ||
                            _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "down")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "question_order", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.question_order) +
                          "\n\t\t\t\t"
                      ),
                      _c(
                        "q-popup-edit",
                        {
                          on: {
                            hide: function($event) {
                              return _vm.reorderItems(props.row)
                            }
                          },
                          model: {
                            value: props.row.question_order,
                            callback: function($$v) {
                              _vm.$set(props.row, "question_order", $$v)
                            },
                            expression: "props.row.question_order"
                          }
                        },
                        [
                          _c("q-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.new_order,
                              callback: function($$v) {
                                _vm.new_order = $$v
                              },
                              expression: "new_order"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          props.row.title.length > 50
                            ? props.row.title.slice(0, 47) + "..."
                            : props.row.title
                        ) +
                        "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "question_type", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              _vm.getSurveyQuestionType(props.row.question_type)
                            )
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c("q-td", { key: "qty_answers", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(props.row.qty_answers) + "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "qty_user_answered", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.qty_user_answered) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-pencil-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.editQuestion(props.row)
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-trash-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmRemoveQuestion(props.row)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_surveys" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "negative",
                  label: _vm.$t("unpublish"),
                  icon: "far fa-ban",
                  disable: _vm.disableButtons
                },
                on: {
                  click: function($event) {
                    return _vm.unpublish()
                  }
                }
              },
              [
                _vm.disableButtons
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("no_questions_are_defined")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "positive",
                  label: _vm.$t("publish"),
                  icon: "far fa-upload",
                  disable: _vm.disableButtons
                },
                on: {
                  click: function($event) {
                    return _vm.publish()
                  }
                }
              },
              [
                _vm.disableButtons
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("no_questions_are_defined")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            hide: function($event) {
              return _vm.clearQuestion()
            }
          },
          model: {
            value: _vm.show_alternatives,
            callback: function($$v) {
              _vm.show_alternatives = $$v
            },
            expression: "show_alternatives"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_alternatives = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("question")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            options: _vm.survey_question_types.map(function(s) {
                              return {
                                label: this$1.$t(s.label),
                                value: s.value
                              }
                            }),
                            error: _vm.$v.question.question_type.$error,
                            "float-label": _vm.$t("question_type")
                          },
                          on: { input: _vm.$v.question.question_type.$touch },
                          model: {
                            value: _vm.question.question_type,
                            callback: function($$v) {
                              _vm.$set(_vm.question, "question_type", $$v)
                            },
                            expression: "question.question_type"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "caption",
                            class: _vm.$v.question.title.$error
                              ? "text-negative"
                              : ""
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("title")) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-editor",
                          {
                            attrs: {
                              error: _vm.$v.question.title.$error,
                              toolbar: [
                                ["bold", "italic", "strike", "underline"],
                                ["left", "center", "right", "justify"],
                                ["link", "upload"],
                                [
                                  {
                                    label: null,
                                    icon: "fas fa-font",
                                    fixedLabel: true,
                                    fixedIcon: true,
                                    list: "no-icons",
                                    options: [
                                      "p",
                                      "h1",
                                      "h2",
                                      "h3",
                                      "h4",
                                      "h5",
                                      "h6",
                                      "code"
                                    ]
                                  },
                                  {
                                    label: null,
                                    icon: "fas fa-text-height",
                                    fixedLabel: true,
                                    fixedIcon: true,
                                    list: "no-icons",
                                    options: [
                                      "size-1",
                                      "size-2",
                                      "size-3",
                                      "size-4",
                                      "size-5",
                                      "size-6",
                                      "size-7"
                                    ]
                                  },
                                  "removeFormat"
                                ],
                                ["quote", "unordered", "ordered"],
                                ["custom_btn"]
                              ],
                              definitions: {
                                bold: { label: null, icon: "fas fa-bold" },
                                italic: { label: null, icon: "fas fa-italic" },
                                strike: {
                                  label: null,
                                  icon: "fas fa-strikethrough"
                                },
                                underline: {
                                  label: null,
                                  icon: "fas fa-underline"
                                },
                                left: {
                                  label: null,
                                  icon: "fas fa-align-left"
                                },
                                center: {
                                  label: null,
                                  icon: "fas fa-align-center"
                                },
                                right: {
                                  label: null,
                                  icon: "fas fa-align-right"
                                },
                                justify: {
                                  label: null,
                                  icon: "fas fa-align-justify"
                                },
                                link: { label: null, icon: "fas fa-link" },
                                upload: {
                                  tip: null,
                                  icon: "fas fa-file-image",
                                  handler: _vm.insertImg
                                },
                                removeFormat: {
                                  label: null,
                                  icon: "fas fa-eraser"
                                },
                                quote: {
                                  label: null,
                                  icon: "fas fa-quote-right"
                                },
                                unordered: {
                                  label: null,
                                  icon: "fas fa-list-ul"
                                },
                                ordered: { label: null, icon: "fas fa-list-ol" }
                              }
                            },
                            on: { input: _vm.$v.question.title.$touch },
                            model: {
                              value: _vm.question.title,
                              callback: function($$v) {
                                _vm.$set(_vm.question, "title", $$v)
                              },
                              expression: "question.title"
                            }
                          },
                          [
                            _c("q-btn", {
                              attrs: {
                                slot: "custom_btn",
                                dense: "",
                                flat: "",
                                color: "black",
                                icon: "fal fa-code",
                                label: "HTML"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show_html = true
                                }
                              },
                              slot: "custom_btn"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm.question.question_type !== 5 && _vm.question.question_type
                    ? _c("q-table", {
                        staticClass: "q-my-lg",
                        attrs: {
                          data: _vm.question.survey_question_answers,
                          title: _vm.$t("alternatives"),
                          columns: _vm.columns_alternatives,
                          loading: _vm.loading,
                          "row-key": "name",
                          "no-data-label": _vm.$t("no_data_avaliable"),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [0],
                          "binary-state-sort": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "q-table-title",
                                      class: _vm.$v.question
                                        .survey_question_answers.$error
                                        ? "text-negative"
                                        : ""
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("alternatives")) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c("div", { staticClass: "col" }),
                                  _c("q-btn", {
                                    attrs: {
                                      color: "secondary",
                                      icon: "far fa-plus",
                                      label: _vm.$t("new_f")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addAlternative()
                                      }
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "header",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  _vm._l(props.cols, function(col) {
                                    return _c(
                                      "q-th",
                                      {
                                        key: col.name,
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t(col.label)) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              }
                            },
                            {
                              key: "body",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-td",
                                      { key: "title", attrs: { props: props } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.title) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "actions",
                                        attrs: { props: props }
                                      },
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            color: "primary",
                                            icon: "far fa-pencil-alt"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.editAlternative(
                                                props.row
                                              )
                                            }
                                          }
                                        }),
                                        _c("q-btn", {
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            color: "negative",
                                            icon: "far fa-trash-alt"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.confirmRemoveAlternative(
                                                props.row
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1384470711
                        )
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "far fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                _vm.show_alternatives = false
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save"),
                              icon: "far fa-save"
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveQuestion()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("confirm") },
                    on: {
                      click: function($event) {
                        return _vm.saveAlternative()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_alternative,
            callback: function($$v) {
              _vm.show_alternative = $$v
            },
            expression: "show_alternative"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("alternative")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { placeholder: _vm.$t("alternative") },
                model: {
                  value: _vm.alternative.title,
                  callback: function($$v) {
                    _vm.$set(_vm.alternative, "title", $$v)
                  },
                  expression: "alternative.title"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeQuestion()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.cancelRemoveAlternative()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeAlternative()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_alternative,
            callback: function($$v) {
              _vm.confirm_remove_alternative = $$v
            },
            expression: "confirm_remove_alternative"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.question.title,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "title", $$v)
                          },
                          expression: "question.title"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }